import { render, staticRenderFns } from "./CustomButton.vue?vue&type=template&id=466760da&scoped=true"
import script from "./CustomButton.vue?vue&type=script&lang=js"
export * from "./CustomButton.vue?vue&type=script&lang=js"
import style0 from "./CustomButton.vue?vue&type=style&index=0&id=466760da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "466760da",
  null
  
)

export default component.exports